/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { STACK_VIEW_DIRECTIVES } from "./index";
var ClrStackViewModule = (function () {
    function ClrStackViewModule() {
    }
    return ClrStackViewModule;
}());
export { ClrStackViewModule };
ClrStackViewModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    STACK_VIEW_DIRECTIVES
                ],
                exports: [
                    STACK_VIEW_DIRECTIVES
                ]
            },] },
];
/** @nocollapse */
ClrStackViewModule.ctorParameters = function () { return []; };
//# sourceMappingURL=stack-view.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/stack-view/stack-view.module.js
// module id = 175
// module chunks = 4